import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Level } from 'fitbeat.gym-core';
import { Text, View, StyleSheet} from 'react-native';
import Theme from '../../theme';
import { CardioOrResistance } from 'fitbeat.models';
import { getBodyImage } from '../../utils/bodyGroupImage';
import { getBodyGroupText, getSkillLevelText } from '../../utils';
import { mappedSkillLevelSvgs } from '../../ui/components/SkillLevelList';
import { defaultScale } from '../../utils/scaling';
import TargetIcon from '../../assets/images/target.svg';
import BenchAndDumbbellsIcon from '../../assets/images/bench-and-dumbbells.svg';
import BuildIcon from '../../assets/icons/activity-types/functional-strength-outlined.svg'
import BurnIcon from '../../assets/icons/activity-types/functional-cardio-outlined.svg'
import BalanceIcon from '../../assets/icons/activity-types/functional-pilates-outlined.svg'
import BenchIcon from '../../assets/images/icon-bench-outline.svg';
import BodyWeightEquipmentIcon from '../../assets/images/icon-bodyweight-outline.svg';
import DumbbellsIcon from '../../assets/images/icon-dumbbells-outline.svg';
import BagContactGlove from '../../assets/images/bag-contact-glove.svg';
import BagContactHand from '../../assets/images/hand-gasture.svg';
import { BaseEquipment } from 'fitbeat.models';

const iconWidth = defaultScale(20);
const iconHeight = defaultScale(20);
class BodyGroupWorkoutSettings extends Component {
  constructor(props) {
    super(props);

    const { t } = this.props;

    const mappedWorkoutType = {
      [CardioOrResistance.Cardio]: {
        title: t('burn'),
        svg: <BurnIcon width={iconWidth} height={iconHeight} color={'#231F20'} strokeWidth={1.2}/>,
      },
      [CardioOrResistance.Resistance]: {
        title: t('build'),
        svg: <BuildIcon width={iconWidth} height={iconHeight} color={'#231F20'} strokeWidth={1.2}/>,
      },
      [CardioOrResistance.Balance]: {
        title: t('balance'),
        svg: <BalanceIcon width={iconWidth} height={iconHeight} color={'#231F20'} strokeWidth={1.2}/>,
      },
    };

    this.state = {
      mappedWorkoutType,
    };
  }
  getEquipmentListIcon = (equipment, themeStyle) => {
    if (BaseEquipment.containsBench(equipment) && BaseEquipment.containsHomeDumbbells(equipment)) {
      return <BenchAndDumbbellsIcon
        stroke={themeStyle.themeColor1}
        strokeWidth={1.2}
        width={iconWidth}
        height={iconHeight} />
    }
    if (BaseEquipment.containsHomeDumbbells(equipment)) {
      return <DumbbellsIcon
        stroke={themeStyle.themeColor1}
        strokeWidth={1.2}
        width={iconWidth}
        height={iconHeight} />
    }
    if (BaseEquipment.containsBodyWeigth(equipment) && equipment.length === 1) {
      return <BodyWeightEquipmentIcon
        stroke={themeStyle.themeColor1}
        strokeWidth={1.2}
        width={iconWidth}
        height={iconHeight} />
    }
    return <BenchIcon
      stroke={themeStyle.themeColor1}
      strokeWidth={1.2}
      width={iconWidth}
      height={iconHeight} />
  }

  render() {
    const {
      t,
      workoutSettings,
      gender,
      showGymEquipment,
      gym,
    } = this.props;

    const { mappedWorkoutType } = this.state;
    const bodyGroups = getBodyGroupText(workoutSettings.threeBodyGroups);
    const equipmentListDisplay = showGymEquipment && workoutSettings?.equipment?.length > 0 &&
      BaseEquipment.getEquipmentCombinationForDisplay(workoutSettings.equipment);
    const equipmentListDisplayIcon = this.getEquipmentListIcon(
      workoutSettings.equipment,
      { themeColor1: Theme.BLACK, themeColor1Inverse: Theme.WHITE },
      );

    const bodyImageWidth =  showGymEquipment ? defaultScale(140) : defaultScale(140);
    const bodyImageHeight =   showGymEquipment ? defaultScale(140) : defaultScale(140);
    const bodyGroupImage = getBodyImage(
      workoutSettings.threeBodyGroups,
      gender,
      workoutSettings.cardioOrResistance,
      bodyImageWidth,
      bodyImageHeight,
    );
    const hasBagContact = gym.bagContactAllowed;

    return (
      <View>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <View style={{ flexDirection: 'column' }}>
            <View
              style={{ flexDirection: 'column', marginRight: defaultScale(30) }}
            >
              <View
                style={[
                  styles.iconTextContainer,
                  { marginBottom: defaultScale(10) },
                ]}
              >
                {mappedWorkoutType[workoutSettings.cardioOrResistance].svg}
                <Text style={styles.iconLabel}>
                  {mappedWorkoutType[workoutSettings.cardioOrResistance].title}
                </Text>
              </View>
              <View
                style={[
                  styles.iconTextContainer,
                  { marginBottom: defaultScale(8)},
                ]}
              >
                {mappedSkillLevelSvgs[workoutSettings.level](iconWidth, iconHeight)}
                <Text style={styles.iconLabel}>{`${
                  getSkillLevelText[workoutSettings.level]
                } Level`}</Text>
              </View>
              <View style={[styles.iconTextContainer, { marginBottom: defaultScale(8)}]}>
                <TargetIcon
                  width={iconWidth}
                  height={iconHeight}
                  fillSecondary={Theme.BLACK}
                  color={Theme.BLACK}
                />
                <Text style={styles.iconLabel}>{bodyGroups}</Text>
              </View>
              {hasBagContact && <View style={[styles.iconTextContainer, { marginBottom: defaultScale(8)}]}>
                {workoutSettings.allowBagContact ?
                <BagContactGlove
                  stroke={Theme.BLACK}
                  width={iconWidth}
                  height={iconHeight} /> :
                <BagContactHand
                  stroke={Theme.BLACK}
                  width={iconWidth}
                  height={iconHeight} />
                }
                <Text style={styles.iconLabel}>{workoutSettings.allowBagContact ? t('Yes') : t('No')}</Text>
              </View>}
            </View>
            {showGymEquipment && <View style={[styles.iconTextContainer, {alignItems: 'flex-start'}]}>
              {equipmentListDisplayIcon}
              <Text style={[
                styles.iconLabel,
                {width: defaultScale(130)},
              ]}>{equipmentListDisplay}</Text>
            </View> }
          </View>
          <View>{bodyGroupImage}</View>
        </View>
      </View>
    );
  }
}

BodyGroupWorkoutSettings.propTypes = {
  workoutSettings: PropTypes.object.isRequired,
  gender: PropTypes.string.isRequired,
  duration: PropTypes.string,
};

const styles = StyleSheet.create({
  iconLabel: {
    ...Theme.textStyle.bodyCopyReg,
    marginLeft: defaultScale(7),
  },
  iconTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default translate(['bookings'], { wait: true })(
  BodyGroupWorkoutSettings,
);
